"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shopperContext = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _crossFetch = _interopRequireDefault(require("cross-fetch"));
var _querystring = _interopRequireDefault(require("querystring"));
var _util = require("./util");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const shopperContext = (usid, config) => {
  return {
    initGuest: () => _initCredentials(usid, {
      grant_type: 'client_credentials'
    }, config),
    initSession: body => _initSession(usid, body, config)
  };
};

// global variable to store credentials
exports.shopperContext = shopperContext;
var _credentials = null;
const getCredentials = () => _credentials;
const setCredentials = val => _credentials = val;
const _initCredentials = (usid, form, config) => {
  return new Promise((resolve, reject) => {
    if (getCredentials()) resolve(getCredentials());
    var formData = _querystring.default.stringify(form);
    var contentLength = formData.length;
    const options = {
      method: 'POST',
      headers: {
        'Content-Length': contentLength.toString(),
        Authorization: (0, _util.getBasicAuth)(config),
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: formData
    };
    (0, _crossFetch.default)(`${(0, _util.getUrl)('auth', config)}oauth2/token${usid ? `?usid=${usid}` : ''}`, options).then( /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)(function* (res) {
        setCredentials(yield res.json());
        resolve(getCredentials());
      });
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()).catch(err => {
      if (err) reject(err);
    });
  });
};
const _initSession = (usid, body, config) => {
  return new Promise((resolve, reject) => {
    const data = JSON.stringify({
      customQualifiers: _objectSpread({}, body)
    });
    const options = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${getCredentials().access_token}`,
        'Content-Type': 'application/json'
      },
      body: data
    };
    (0, _crossFetch.default)(`${(0, _util.getUrl)('shopper-context', config)}/shopper-context/${usid}`, options).then( /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)(function* (res) {
        const result = yield res.text();
        resolve(result);
      });
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()).catch(err => {
      if (err) reject(err);
    });
  });
};